import { Component, OnInit } from '@angular/core';
import {ProductsService} from "../../../../../../services/products/products.service";
import {ToastrService} from "ngx-toastr";
import {ActivatedRoute} from "@angular/router";
import {Product} from "../../../../../../models/Product";


@Component({
  selector: 'app-tva-product',
  templateUrl: './tva-product.component.html',
  styleUrls: ['./tva-product.component.scss']
})
export class TvaProductComponent implements OnInit {
    productId!: number;
    productData: any = {};
  constructor(private productsService : ProductsService,
              private route: ActivatedRoute,
              private toastr: ToastrService) { }

  ngOnInit(): void {
      this.productId = +this.route.parent?.snapshot.paramMap.get('id')!;
      this.getProduct();
  }

    getProduct(): void {
        this.productsService.getDetailsProduct(this.productId).subscribe({
            next: (response: Product) => {
                this.productData = response;
                // console.log(this.productData);
            },
            error: (err) => {
                this.toastr.error('Erreur lors du chargement du produit');
            }
        });
    }

}
